import classNames from 'clsx';
import React from 'react';

import type { ImageFetchProps } from '../../model/types';

import styles from './BannerImage.scss';

interface BannerImageProps extends ImageFetchProps {
  image?: string;
  isCenterImage?: boolean;
}

const BannerImage: React.FC<BannerImageProps> = ({ image, priority, isCenterImage }) =>
  image ? (
    <img
      className={classNames(styles.image, { [styles.centerImage]: isCenterImage })}
      src={image}
      alt=""
      loading={priority === 'high' ? 'eager' : 'lazy'}
      fetchPriority={priority}
    />
  ) : null;

export default BannerImage;
